"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super.call(this) || this;
        _this.username = '';
        _this.password = '';
        _this.display = false;
        _this.authGoogleUrl = null;
        _this.remember = false;
        _this.loader = false;
        _this.showInvalidUserError = false;
        return _this;
    }
    Login.prototype.mounted = function () {
        var _this = this;
        this.$oAuth2.getUserTokenData().then(function (tokenData) {
            _this.display = tokenData === null;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
        this.$root.$on('SESSION_DESTROY_EVENT', function () {
            _this.display = true;
        });
        this.$root.$on('ASK_USER_CREDENTIALS', function () {
            _this.openLoginModal();
        });
    };
    Login.prototype.openLoginModal = function () {
        var _this = this;
        this.$bvModal.show('login-modal');
        this.username = '';
        this.password = '';
        this.remember = false;
        this.loader = false;
        this.showInvalidUserError = false;
        this.$getUrlForAuthenticateService.request().then(function (response) {
            _this.authGoogleUrl = response.url;
        }, function (error) {
            _this.$bvModal.hide('login-modal');
            _this.$router.push({ name: 'error', params: { code: error.response.status } });
        });
    };
    Login.prototype.submit = function () {
        return __awaiter(this, void 0, Promise, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 6]);
                        return [4 /*yield*/, this.$oAuth2.authenticateByPassword(this.username, this.password, this.remember)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.$oAuth2.getUserTokenData()];
                    case 3:
                        if ((_a.sent()) === null) {
                            this.showInvalidUserError = true;
                        }
                        else {
                            this.display = this.showInvalidUserError = false;
                            this.$root.$emit('AUTHENTICATED_EVENT');
                        }
                        this.loader = false;
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        this.$bvModal.hide('login-modal');
                        return [4 /*yield*/, this.$router.push({ name: 'error', params: { code: '500' } })];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Login.prototype.signUpWithGoogle = function () {
        if (this.authGoogleUrl !== null) {
            window.location.href = this.authGoogleUrl;
        }
    };
    Login = __decorate([
        vue_property_decorator_1.Component({
            name: 'Login'
        })
    ], Login);
    return Login;
}(vue_1.default));
exports.default = Login;
